import { EventKind } from "./event-kind"

export enum EventCategory {
    Layers = "layers",
    Comments = "comments",
    Access = "access",
    Pdfs = "pdfs",
    PilotTracking = "pilotTracking",
    Atlas = "atlas",
}

export enum EventAction {
    Created = "created",
    Uploaded = "uploaded",
    Processed = "processed",
    ProcessingFailed = "processingFailed",
    Exported = "exported",
    Generated = "generated",
    Deleted = "deleted",
    Archived = "archived",
    Unarchived = "unarchived",
    Started = "started",
    Ended = "ended",
    Shared = "shared",
    Requested = "requested",
    Granted = "granted",
    Removed = "removed",
    Failed = "failed",
}

export type EventTaxonomyEntry = {
    category: EventCategory
    action: EventAction
}

export const eventTaxonomy = {
    [EventKind.LayerCreated]: { category: EventCategory.Layers, action: EventAction.Created },
    [EventKind.LayerDeleted]: { category: EventCategory.Layers, action: EventAction.Deleted },
    [EventKind.LayerProcessed]: { category: EventCategory.Layers, action: EventAction.Processed },
    [EventKind.LayerProcessingFailed]: {
        category: EventCategory.Layers,
        action: EventAction.ProcessingFailed,
    },
    [EventKind.LayerArchived]: { category: EventCategory.Layers, action: EventAction.Archived },
    [EventKind.LayerUnarchived]: { category: EventCategory.Layers, action: EventAction.Unarchived },
    [EventKind.EntityCreated]: { category: EventCategory.Layers, action: EventAction.Created },
    [EventKind.EntityDeleted]: { category: EventCategory.Layers, action: EventAction.Deleted },
    [EventKind.EntityArchived]: { category: EventCategory.Layers, action: EventAction.Archived },
    [EventKind.EntityUnarchived]: {
        category: EventCategory.Layers,
        action: EventAction.Unarchived,
    },
    [EventKind.StreamStarted]: { category: EventCategory.Layers, action: EventAction.Started },
    [EventKind.StreamEnded]: { category: EventCategory.Layers, action: EventAction.Ended },
    [EventKind.LocationSharingStarted]: {
        category: EventCategory.Atlas,
        action: EventAction.Started,
    },
    [EventKind.LocationSharingEnded]: { category: EventCategory.Atlas, action: EventAction.Ended },
    [EventKind.StreamShared]: { category: EventCategory.Access, action: EventAction.Shared },
    [EventKind.MissionGroupStreamShared]: {
        category: EventCategory.Access,
        action: EventAction.Shared,
    },
    [EventKind.MissionGroupDashboardShared]: {
        category: EventCategory.Access,
        action: EventAction.Shared,
    },
    [EventKind.PdfGenerated]: { category: EventCategory.Pdfs, action: EventAction.Generated },
    [EventKind.PdfFailed]: { category: EventCategory.Pdfs, action: EventAction.Failed },
    [EventKind.AccessRequested]: { category: EventCategory.Access, action: EventAction.Requested },
    [EventKind.AccessGranted]: { category: EventCategory.Access, action: EventAction.Granted },
    [EventKind.AccessRemoved]: { category: EventCategory.Access, action: EventAction.Removed },
    [EventKind.CommentCreated]: { category: EventCategory.Comments, action: EventAction.Created },
    [EventKind.CommentDeleted]: { category: EventCategory.Comments, action: EventAction.Deleted },
} satisfies { [K in EventKind]: EventTaxonomyEntry }

export const eventKindsByCategory = (category: EventCategory) =>
    (Object.keys(eventTaxonomy) as EventKind[]).filter(
        (kind) => eventTaxonomy[kind].category === category
    )
